export default `
  mutation clearChatLog($projectId: ID!, $workflowId: ID!) {
    clearChatLog(projectId: $projectId, workflowId: $workflowId)
  }
`
